import {React, useEffect, useState} from 'react'
import { useTranslate, useNotify } from 'react-admin'
import {
    Button,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Dialog,
    DialogTitle,
    DialogContent,
    Skeleton,
    Container,
    TableFooter,
    TablePagination,
    Box
  } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import EditIcon from '@mui/icons-material/Edit';
import { NotificationForm } from '../../../notification/logic/NotificationForm';
import {notificationServices} from 'src/services/sales/notification/notification.service.ts'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_CREATE} from 'src/helper/Permission'
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReplyIcon from '@mui/icons-material/Reply';
import { parseDateFormat } from 'src/helper/parseDateFormat'
import "./NotificationsStyles.css"
import { HasPermission } from 'src/helper/HasPermission'
import { PERMISSION_SHOW, PERMISSION_REPLY, PERMISSION_EDIT, PERMISSION_DELETE} from 'src/helper/Permission'
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import RefreshIcon from '@mui/icons-material/Refresh';
import { GeneralSearch } from '../../../notification/logic/GeneralSearch';

export const NotificationsList = ({record, setReloadNotifications, reloadNotifications}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [openCreateDialog, setOpenCreateDialog] = useState(false)
    const [notificationId, setNotificationId] = useState(null)
    const [mode, setMode] = useState('')
    const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10 })
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [notificationToDelete, setNotificationToDelete] = useState(null)
    const [loadingDelete, setLoadingDelete] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [openGeneralSearchDialog, setOpenGeneralSearchDialog] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [loadingNotifications, setLoadingNotifications] = useState(false)

    const getNotifications = async () =>{
      setLoadingNotifications(true)
      await notificationServices.getNotificationByParam({ reservation:record.number}).then(res=>{
        setNotifications(res.issues)
      })
      .finally(()=>{
        setLoadingNotifications(false)
      })
    }
    
    useEffect(()=>{
      getNotifications()
    },[reloadNotifications])

    const onDelete = async() =>{
      const auxiliarForm = {
        project_id:notificationToDelete.project?.id,
        assigned_to_id:notificationToDelete.assigned_to?.id,
        watchers:notificationToDelete.watchers,
        subject:notificationToDelete.subject,
        description:notificationToDelete.description,
        notes:notificationToDelete.notes,
        tracker_id:17,
        status_id:15,
        priority_id:3,
        custom_fields:notificationToDelete.custom_fields
      }
      setLoadingDelete(true)
      const formData = new FormData();
      formData.append('payload', JSON.stringify(auxiliarForm));
      await notificationServices.editNotification(formData, notificationToDelete.id).then(res=>{
        setOpenDeleteDialog(false)
        notify('ra.message.delete_notification_success',{type:'success'})
      }).catch(()=>{
        notify('ra.message.delete_notification_error',{type:'error'})
      }).finally(()=>{
        setLoadingDelete(false)
      })
      
    }
    
      useEffect(()=>{
        if(confirmDelete){
          onDelete()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[confirmDelete])

    const statusStyleBox = (status) =>{
      if(status === 1){
        return {backgroundColor:'rgb(11, 215, 215)'}
      }
      if(status === 2){
        return {backgroundColor:'rgb(237, 158, 39)'}
      }
      if(status === 9){
        return {backgroundColor:'rgb(5, 158, 53)'}
      }
      if(status === 11){
        return {backgroundColor:'rgb(7, 78, 178)'}
      }
    }

    const onPageItemChange = (number) => {
      const paginationItemDataAux = { ...paginationItemData }
      paginationItemDataAux.page = number
      setPaginationItemData(paginationItemDataAux)
    }
  
    const onRowsPerPageItemChange = (e) => {
      const paginationItemDataAux = { ...paginationItemData }
      paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
      paginationItemDataAux.page = 0
      setPaginationItemData(paginationItemDataAux)
    }
  
    const getItemsData = () => {
      return paginationItemData.rowsPerPage > 0
        ? notifications
            ?.slice(
              paginationItemData.page * paginationItemData.rowsPerPage,
              paginationItemData.page * paginationItemData.rowsPerPage + paginationItemData.rowsPerPage
            )
        : notifications
    }

    const onShow = (id) =>{
      setNotificationId(id)
      setMode('show')
      setOpenCreateDialog(true)
    }

    const onReply = (id) =>{
      setNotificationId(id)
      setMode('reply')
      setOpenCreateDialog(true)
    }

    const onEdit = (id) =>{
      setNotificationId(id)
      setMode('edit')
      setOpenCreateDialog(true)
    }

    const onCreate = () =>{
      setNotificationId(null)
      setMode('create')
      setOpenCreateDialog(true)
    }
  return (
    <Container className='content'>
        <CardCommon title={translate('ra.field.notification')}>
        {hasPermissionFunction('notification', PERMISSION_CREATE) && (
          <Button
              onClick={onCreate}
              sx={{display:'flex',justifySelf:'flex-end'}}
              size='small'
              variant='contained'
              >
              <div style={{padding:'3px',display:'flex',alignItems:'center', flexDirection:'row',justifyContent:'space-evenly'}}>
                  <div style={{padding:'4px'}}>
                      {translate('ra.action.new_message')}
                  </div>
                  <EditIcon sx={{fontSize:'medium'}}/>
              </div>
          </Button>
        )}
        <HasPermission permission={'search'} resource={'notification'}>
          <Button
            variant='contained'
            sx={{display:'flex',justifySelf:'flex-end', marginTop:'15px'}}
            onClick={()=>{setOpenGeneralSearchDialog(true)}}
          >
            {translate('ra.action.general_search')}
          </Button>
        </HasPermission>
        <RefreshIcon onClick={()=>setReloadNotifications(!reloadNotifications)} sx={{display:'flex',justifySelf:'flex-end', marginTop:'15px', cursor:'pointer'}}/>
        <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{translate('ra.field.state')}</TableCell>
                  <TableCell>{'ID'}</TableCell>
                  <TableCell>{translate('ra.field.type')}</TableCell>
                  <TableCell>{translate('ra.field.subject')}</TableCell>
                  <TableCell>{translate('ra.field.created_at')}</TableCell>
                  <TableCell>{translate('ra.field.last_update_date')}</TableCell>
                  <TableCell>{translate('ra.field.creation_user')}</TableCell>
                  <TableCell>{translate('ra.field.assigned')}</TableCell>
                  <TableCell>{translate('ra.title.actions')}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingNotifications ? (
                  <TableRow>
                    {[...Array(8)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' width={'100%'} height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  getItemsData()?.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Box className='statusBox' style={statusStyleBox(row.status?.id)}>{row.status?.name} </Box>
                      </TableCell>
                      <TableCell>
                        {row?.id}
                      </TableCell>
                      <TableCell>{row?.project?.name}</TableCell>
                      <TableCell>{row?.subject}</TableCell>
                      <TableCell>{parseDateFormat(row?.created_on)}</TableCell>
                      <TableCell>
                        {parseDateFormat(row?.updated_on)}
                      </TableCell>
                      <TableCell>
                        {row?.author?.name}
                      </TableCell>
                      <TableCell>
                        {row?.assigned_to?.name}
                      </TableCell>
                      <TableCell>
                        <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-evenly'}}>
                          <HasPermission permission={PERMISSION_SHOW} resource={'notification'}>
                            <VisibilityIcon onClick={()=>onShow(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          <HasPermission permission={PERMISSION_REPLY} resource={'notification'}>
                            <ReplyIcon onClick={()=>onReply(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          <HasPermission permission={PERMISSION_EDIT} resource={'notification'}>
                            <EditIcon onClick={()=>onEdit(row.id)} style={{cursor:'pointer'}}/>
                          </HasPermission>
                          <HasPermission permission={PERMISSION_DELETE} resource={'notification'}>
                            <DeleteIcon onClick={()=>{setNotificationToDelete(row);setOpenDeleteDialog(true)}} style={{cursor:'pointer'}}/>
                          </HasPermission>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    count={notifications?.length}
                    rowsPerPage={paginationItemData.rowsPerPage}
                    page={paginationItemData.page}
                    onPageChange={(e, number) => onPageItemChange(number)}
                    onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                    labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                    }
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </CardCommon>
        <Dialog open={openCreateDialog}  fullWidth maxWidth='lg' onClose={()=>{setOpenCreateDialog(false)}}>
                <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.field.notification')}
                  <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setOpenCreateDialog(false)}}/>
                </DialogTitle>
                <DialogContent>
                    <NotificationForm reload={reloadNotifications} setReload={setReloadNotifications}setDialogOpen={setOpenCreateDialog} notificationId={notificationId} mode={mode}/>
                </DialogContent>
        </Dialog>
        <Dialog open={openGeneralSearchDialog}  /* fullWidth maxWidth='lg' */ onClose={()=>{setOpenGeneralSearchDialog(false)}}>
                <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.field.notification')}
                  <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setOpenGeneralSearchDialog(false)}}/>
                </DialogTitle>
                <DialogContent>
                    <GeneralSearch/>
                </DialogContent>
        </Dialog>
        <ConfirmationDialog
            setOpen={setOpenDeleteDialog}
            setConfirm={setConfirmDelete}
            buttonConfirmText={translate('ra.action.acept')}
            buttonCancel={translate('ra.action.cancel')}
            open={openDeleteDialog}
            loadingModalButton={loadingDelete}
            contentText={translate('ra.message.delete_notification_confirm')}
        />
      </Container>
  )
}
